<template>
  <div class="step-content">
    <div class="step-content__row">
      <div>
        <span class="step-content__text"
          >Square Footage Size Discount 1 sq.ft.</span
        >
      </div>
      <span class="step-content__text center">$ — {{ discountIndex }}</span>
    </div>

    <div class="step-content__row">
      <div>
        <span class="step-content__text">Installation Discount Amount</span>
      </div>

      <PriceValue :price="discountSum" class="step-content__text center" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from "vue";
import { PriceValue } from "@/shared";
import { useInstallationStore } from "@/stores/new/installation.store";
import { useNewEstimateStore } from "@/stores/new/estimateStore";

const estimateStore = useNewEstimateStore();
const newInstallationStore = useInstallationStore();

const discountSum = computed(() => newInstallationStore.discountSum);
const discountIndex = computed(() => newInstallationStore.discountIndex);
const dealType = computed(() => estimateStore.estimate.dealTypeCode);

const installationItemList = computed(
  () => newInstallationStore.installationItemList,
);
watch(
  () => installationItemList.value,
  () => {
    if (installationItemList.value.length > 0) {
      newInstallationStore.createInstallationDiscount();
    }
  },
  { deep: true },
);
</script>

<style scoped>
.step-content {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  align-items: flex-start;

  margin-top: 32px;
}

.step-content__row {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 100px;
  align-items: center;
}

.step-content__text {
  color: #052141;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.step-content__text.center {
  text-align: right;
}
</style>
